import { l } from '@js/utils/toolbox';

export const footer = (id, forwardURL) => {
	return `
		<button class="js-close-modal abBtn abBtn--flex abBtn--whiteBlue">
			<span>${l('global.simplePhrases.close')}</span>
		</button>
		<div class="abBtn abBtn--blueWhite abBtn--flex kallebakom_cta kallebakom_maincta" data-value="0" data-kalleid="${id}" data-url="${forwardURL}">
			${l('kallebakom.' + id + '.cta')}
		</div>
	`;
};
